export default "__VITE_ASSET__DBPIDNIB__"